/* ============================================================
   ELEPHONE Theme JS — assets/elephone.js
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  /* ── Nav shadow on scroll ── */
  const header = document.getElementById('site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 20);
    }, { passive: true });
  }

  /* ── Mobile menu ── */
  const hamburger = document.querySelector('.hamburger');
  const mobileMenu = document.querySelector('.mobile-menu');
  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', () => {
      const open = mobileMenu.classList.toggle('open');
      hamburger.setAttribute('aria-expanded', open);
    });
  }

  /* ── Condition tabs (catalogue filtering) ── */
  const tabs = document.querySelectorAll('.ctab[data-condition]');
  const cards = document.querySelectorAll('.product-card[data-condition]');
  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      tabs.forEach(t => t.classList.remove('active'));
      tab.classList.add('active');
      const val = tab.dataset.condition;
      cards.forEach(card => {
        if (val === 'all' || card.dataset.condition === val) {
          card.style.display = '';
        } else {
          card.style.display = 'none';
        }
      });
    });
  });

  /* ── Product gallery thumbnails ── */
  const thumbs = document.querySelectorAll('.gallery-thumb');
  const mainImg = document.querySelector('.gallery-main img');
  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      if (mainImg && thumb.dataset.src) {
        mainImg.src = thumb.dataset.src;
      }
    });
  });

  /* ── Add to cart AJAX ── */
  document.querySelectorAll('[data-add-to-cart]').forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      const variantId = btn.dataset.variantId;
      if (!variantId) return;
      btn.disabled = true;
      btn.textContent = '...';
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        if (res.ok) {
          updateCartCount();
          btn.textContent = '✓';
          setTimeout(() => {
            btn.textContent = '+';
            btn.disabled = false;
          }, 1500);
        }
      } catch (err) {
        btn.textContent = '+';
        btn.disabled = false;
      }
    });
  });

  /* ── Update cart count ── */
  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js');
      const data = await res.json();
      const badge = document.querySelector('.cart-count');
      if (badge) {
        badge.textContent = data.item_count;
        badge.style.display = data.item_count > 0 ? 'flex' : 'none';
      }
    } catch(e) {}
  }
  updateCartCount();

  /* ── Intersection observer for fade-up ── */
  const fadeEls = document.querySelectorAll('.reveal');
  if (fadeEls.length) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('fade-up');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    fadeEls.forEach(el => io.observe(el));
  }

  /* ── Battery health color ── */
  document.querySelectorAll('.battery-fill').forEach(bar => {
    const pct = parseInt(bar.style.width);
    if (pct >= 85) bar.style.background = 'var(--lima-dark)';
    else if (pct >= 70) bar.style.background = 'var(--amarillo)';
    else bar.style.background = 'var(--coral)';
  });

});
